import type { JSX } from 'react';
import { ConfigSection } from '../components/ConfigSection.js';

export function PlansPage(): JSX.Element {
  return (
    <ConfigSection
      title={"Planos, limites e mapeamento de produtos"}
      description={"Área do plano que depende de código ou credencial externa."}
      blockedBy={[
      'Endpoints de administração de plano (`/v1/admin/plans`) ainda não implementados.',
      'Mapping de produto→plano precisa dos IDs reais de produto da App Store e do Google Play.'
]}
      planned={[
      'Listar planos, limites, mapping de produtos e histórico de publicação.',
      'Preservar termos de assinaturas vigentes ao publicar versão nova.'
]}
    />
  );
}